import * as Sentry from "@sentry/react";
import debounce from "lodash/debounce";
import { renderStripeCheckoutError } from "./checkout";
import { subdomainParamsFromReq } from "./subdomain";
import QS from "qs";
import { API_PATHS } from "./paths";
import { PAGE_KEYS, preparePageResponse } from "./render";
import { CHECKOUT_SESSION_ERROR_CONTENT } from "./constants/error";

const DIALOG_CLASS_NAME = "sentry-error-embed-wrapper";

const debouncedDialog = debounce((event, user) => {
  Sentry.showReportDialog({ eventId: event.event_id, ...user });
}, 500);

export const showErrorDialog = (user) => (event) => {
  const notShown =
    document.getElementsByClassName(DIALOG_CLASS_NAME).length === 0;

  /**
   * Check if it is an exception, and if so, show the report dialog
   * Ensure not show too many times by debouncing
   * */
  if (event.exception && notShown) {
    debouncedDialog(event, user);
  }
  return event;
};

export const captureException = (error) =>
  process.env.NODE_ENV === "production" && Sentry.captureException(error);

export const getErrorServerSideProps = async ({ req, query }) => {
  /**
   * 1. Get subdomain params for query
   */
  const params = subdomainParamsFromReq({ req });

  /**
   * 2. Get test / live link request route
   * - extended with query params
   * - e.g. /v1/stripe/checkout/error?shortId=abc
   */
  const REQUEST_URL = `${API_PATHS.CHECKOUT_ERROR}?${QS.stringify({
    subdomain: params.subdomain,
    shortId: query.shortId
  })}`;

  /**
   * 3. Render checkout error page summary for live / test context
   * - This is a GET to the provided url
   * - Generate the checkout payload on the server to prevent leaking of Stripe models to the client
   */
  const data = await renderStripeCheckoutError(REQUEST_URL);

  /**
   * 4. Prepare response shape data
   */
  const response = preparePageResponse({
    data,
    params,
    keys: PAGE_KEYS.CHECKOUT.ERROR,
    errorContent: CHECKOUT_SESSION_ERROR_CONTENT
  });

  return {
    props: response
  };
};
